import { LocalService } from './../storage/local.service';
import { Injectable } from '@angular/core';

import { ConfigService } from './../config/config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_ENDPOINT } from '../config/config';

@Injectable({
  providedIn: 'root',
})
export class TurnosService {
  headers = new HttpHeaders({
    'accept': 'application/json',
    'Content-Type': 'application/json',
  });

  constructor(
    private httpClient: HttpClient,
    private config: ConfigService,
    private localSecureService: LocalService
    ) {}

  async pedirTurno(data: any) {
    //const config = await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/pedirturno`;

    try {
      return await this.httpClient
        .post(url, data, { headers: this.headers })
        .toPromise();
    } catch (error: any) {
      return {
        error
      };
    }
  }

  async nuevoTurno(data: any) {
    //const config = await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/newturn`;

    try {
      return await this.httpClient
        .post(url, data, { headers: this.headers })
        .toPromise();
    } catch (error: any) {
      return {
        status: false,
        code: error.error.status,
        message: error.error.title,
      };
    }
  }

  async iniciaTurno(data: any) {
    //const config = await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/procesaturno`;

    try {
      return await this.httpClient
        .post(url, data, { headers: this.headers })
        .toPromise();
    } catch (error: any) {
      return {
        status: false,
        code: error.error.status,
        message: error.error.title,
      };
    }
  }

  async finTurno(data: any) {
    //const config = await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/cierraturno`;

    try {
      return await this.httpClient
        .post(url, data, { headers: this.headers })
        .toPromise();
    } catch (error: any) {
      return {
        status: false,
        code: error.error.status,
        message: error.error.title,
      };
    }
  }

  async derivarTurno(data: any) {
    //const config = await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/derivar`;

    try {
      return await this.httpClient
        .post(url, data, { headers: this.headers })
        .toPromise();
    } catch (error: any) {
      return {
        status: false,
        code: error.error.status,
        message: error.error.title,
      };
    }
  }

  async cierraTurno(data: any) {
    //const config = await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/cierraturno2`;

    try {
      return await this.httpClient
        .post(url, data, { headers: this.headers })
        .toPromise();
    } catch (error: any) {
      return {
        error: true,
        code: error.error.status,
        message: error.error.title,
      };
    }
  }

  async setDataById(data: any) {
    const customer = this.localSecureService.getValue('customer');
    const url = `${API_ENDPOINT.api_auxiliar.url}/Consultora/DatosCliente?Slug=${ customer['slug'] }`;
    const headers = new HttpHeaders({
      'accept': 'application/json',
      'Content-Type': 'application/json',
      skipApiKeyInterceptor: 'true',
      ApiKey: API_ENDPOINT.api_auxiliar.apiKey
    })

    try {
      return await this.httpClient
        .post(url, data, { headers: headers })
        .toPromise();
    } catch (error: any) {
      return {
        error: true,
        code: error.error.status,
        message: error.error.title,
      };
    }
  }
}
